import {observable} from "mobx";
import {consoleApi} from "../apiMiddleware";
import { message } from "antd";
import {ServiceTypeEnum} from "../components/portal/serviceCenter/ProjectDetail";

export type RoomInfType = {
    id: number;
    uuid: string;
    teamId: number;
    adminId: number;
    limit: number;
    current: number;
    enable: boolean;
    createdAt: string;
    akkoVersion: string;
    mode: string;
};

export type ServiceData = {
    id: number,
    teamId: number,
    enable: boolean,
    type: ServiceTypeEnum,
    configuration: string,
    createdAt: string,
    updatedAt: string,
};

export type ResServiceData = { code: number, data: { services: ServiceData[] } };

export class RoomStore {
    @observable
    public productState: ServiceData[] = [];
    public async getService(): Promise<void> {
        try {
            const resp: ResServiceData  = await consoleApi.data.getMyService();
            if (resp.code === 200) {
                this.productState = resp.data.services;
            }
        } catch (err) {
            message.error(err.message);
        }
    }
}
export const roomStore = new RoomStore();



// WEBPACK FOOTER //
// ./src/models/RoomStore.ts